import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Typography, CircularProgress, Container, Alert, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("Processing your payment and finalizing account setup...");

  useEffect(() => {
    // Wait for webhook to process the payment and update user profile
    const timer = setTimeout(() => {
      setMessage("Redirecting to your dashboard...");
      
      // Clear any temporary session storage data
      sessionStorage.removeItem('completedQuizData');
      sessionStorage.removeItem('quizAnswers');
      sessionStorage.removeItem('currentQuizQuestion');
      sessionStorage.removeItem('signupData');
      sessionStorage.removeItem('selectedSubscriptionType');
      
      // Redirect to auth callback to refresh user profile
      navigate('/auth/callback?from_payment=true'); 
    }, 3000); // Reduced to 3 seconds since webhook should handle everything

    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  if (error) {
    return (
      <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
          <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
            There was an issue finalizing your setup. Please contact support if the problem persists.
          </Typography>
          <Button
            onClick={() => navigate('/dashboard')}
            variant="contained"
            color="primary"
          >
            Go to Dashboard
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
        <Typography component="h1" variant="h4" gutterBottom>
          Payment Successful!
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, textAlign: 'center' }}>
          Thank you for your subscription. Your access has been updated.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          {message}
        </Typography>
        {message.includes("Redirecting") && <CircularProgress size={24} sx={{mb: 2}} />}
        <Button
          onClick={() => navigate('/auth/callback?from_payment=true')}
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
        >
          Go to App Now
        </Button>
      </Paper>
    </Container>
  );
};

export default PaymentSuccess;
